module.exports = __webpack_public_path__ + "static/media/10.42e8b91c.jpg";